module.exports = __webpack_public_path__ + "images/embed/label_today.png";